import React from "react";
import { NotificationManager } from "react-notifications";
import Button from "./Button";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    NotificationManager.error("Something went wrong.", "Failure", 5000);
    console.error(error, errorInfo);
  }

  handleTryAgain = () => {
    // Reset the state so the next render will show the original UI.
    this.setState({ hasError: false });
    // Here you could also add some logic to "try again",
    // for example re-fetching some data or redirecting to a different page.
  };

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="pl-24 flex flex-col justify-center items-center h-full">
          <h1 className="text-lg pb-4">Sorry, something went wrong.</h1>
          <Button className="button" onClick={this.handleTryAgain} text="Try Again" />
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
